export default {
  title: 'Product List',
  addProduct: 'Add Product',
  editProduct: 'Edit Product',
  productName: 'Product Name',
  productNo: 'Product No.',
  productCategory: 'Product Category',
  productLang: 'Language',
  id: 'ID',
  productInfo: 'Product Info',
  retailPrice: 'Retail Price',
  spec: 'Spec',
  singleSpec: 'Single Spec',
  multiSpec: 'Multi Spec',
  detail: 'Detail',
  multiSpecModal: 'Multi Spec Info',
  specNo: 'Spec No.',
  specInfo: 'Spec Info',
  price: 'Price',
  select: 'Select',
  selected: 'Selected',
  selectedProducts: 'Selected Products',
  unselectedProducts: 'Unselected Products',
};
